import React from "react";
import {connect} from "react-redux";
import BsDataTable from "components/data-table/BsDataTable";
import BsTabPanel from "components/panel/BsTabPanel";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import {exportLabelRentalsToCsv, loadLabelRentals} from "core/actions/rental-actions";
import {LABEL_CLIENT_TABLE_USER_RENTALS} from "./label-client-user-rentals-table";
import LabelClientUserRentalsFilters from "./LabelClientUserRentalsFilters";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";

const queryString = require('query-string');

class LabelClientUserRentalsTab extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        bikeNumber: query.bikeNumber != null ? query.bikeNumber : '',
        systemName: query.systemName != null ? query.systemName : ''
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.bikeNumber = this.state.fields.bikeNumber;
    params.systemName = this.state.fields.systemName;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.systemName;
    delete params.bikeNumber;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        bikeNumber: '',
        systemName: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadLabelRentals(this.props.match.params.labelId, this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/label/' + this.props.match.params.labelId +
        '/user-info/' + this.props.match.params.userId + '/rental/' + row.id)
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    if (query.bikeNumber) {
      query['bike.number'] = query.bikeNumber;
    }
    if (query.systemName) {
      query['system.name'] = query.systemName;
    }
    query['client.id'] = this.props.match.params.userId;
    return query
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportLabelRentalsToCsv(this.props.match.params.labelId, this.prepareQuery(query));
  }

  render() {
    return (
        <BsTabPanel>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="outlined" type="button" onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            }>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <LabelClientUserRentalsFilters fields={this.state.fields}
                                           onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={LABEL_CLIENT_TABLE_USER_RENTALS}
                       content={this.props.rentals}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    rentals: state.rental.labelRentals,
    loading: state.rental.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadLabelRentals: (labelId, query) => {
      dispatch(loadLabelRentals(labelId, query));
    },
    exportLabelRentalsToCsv: (labelId, query) => {
      dispatch(exportLabelRentalsToCsv(labelId, query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelClientUserRentalsTab);
